// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-calendar-table[data-v-2c4ad65c]{width:100%}.el-calendar-table .el-calendar-day[data-v-2c4ad65c]{box-sizing:border-box;padding:8px;height:32px}.table_body[data-v-2c4ad65c]{background-color:#fafafa}[data-v-2c4ad65c] td.is-selected{color:#fff!important;background-color:#1890ff!important}[data-v-2c4ad65c] .el-calendar-day:hover{cursor:pointer;color:#fff;background-color:#1890ff!important}", ""]);
// Exports
module.exports = exports;
